<template>
  <div class="content">
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>疫情防控</el-breadcrumb-item>
            <el-breadcrumb-item>测温统计</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container class="content-container">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!-- 上 -->
          <div class="search-section">
            <div style="display:flex;align-items:center">
              <span>日期：</span>
              <el-date-picker v-model="search.time" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"
                style="margin-right:10px;"></el-date-picker>
              <span>体温状态：</span>
              <el-select v-model="search.temperatureType" placeholder="请选择" @change="selcetKu"
                style="margin-right:10px;">
                <el-option v-for="item in backTemperatures" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <span>健康码状态：</span>
              <el-select v-model="search.healthLevel" placeholder="请选择" @change="selcetKu" style="margin-right:10px;"
                clearable>
                <el-option v-for="item in codehealth" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>
            </div>
            <div style="display:flex;align-items:center">
              <el-button type="primary" class="add-user" @click="exportOut">导出报表</el-button>
            </div>
          </div>
          <!-- 表格 -->
          <div class="build-table">
            <el-table :data="listData" border height="100%" style="width: 100%;">
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>              
              <el-table-column label="序号" width="60">
                <template slot-scope="scope">
                  <a>{{ scope.row.index}}</a>
                </template>
              </el-table-column>
              <el-table-column label="抓拍头像">
                <template slot-scope="scope">
                  <el-image style="width: 100px; height: 100px" :src="scope.row.photoFile"
                    :preview-src-list="scope.row.photos"></el-image>
                </template>
              </el-table-column>
              <el-table-column label="体温">
                <template slot-scope="scope">
                  <span v-if="scope.row.temperature > 37.3" style="color:red;">{{ scope.row.temperature }}℃</span>
                  <span v-else style="color:#00C850;">{{ scope.row.temperature }}℃</span>
                </template>
              </el-table-column>
              <el-table-column label="监测时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.clockTime }}</span>
                </template>
              </el-table-column>
              <el-table-column label="健康码状态">
                <template slot-scope="scope">
                  <img :src="scope.row.codeImg" style="height: 6vh" />
                </template>
              </el-table-column>
              <!-- <el-table-column label="联系方式">
            <template slot-scope="scope">
              <span>{{ scope.row.tbphone }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注">
            <template slot-scope="scope">
              <span>{{ scope.row.note }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.approval=='0'" style="color:#4263F3;">等待审批</span>
              <span v-else-if="scope.row.approval=='1'" style="color:#00C850;">同意复工</span>
              <span v-else-if="scope.row.approval=='2'" style="color:#FF8001;">不同意复工</span>
            </template>
          </el-table-column>
          <el-table-column label="管理">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
            </template>
              </el-table-column>-->
            </el-table>
          </div>
          <div class="el-end">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="currentPage" :page-sizes="[3, 5, 10, 20]" :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="totalItems"></el-pagination>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
  import util from '../../../../untils/util'
  import myHttp from '../../../../untils/port'
  import base from '../../../../untils/base'
  export default {
    data() {
      return {
        search: {
          //查询
          temperatureType: '0',
          time: util.myTime.getCurTime(),
          groupType: '',
          groupId: '',
          healthLevel: ''
        },
        listData: [], //表格数据
        backTemperatures: [
          //体温异常
          { id: '0', name: '不限' },
          { id: '1', name: '正常' },
          { id: '2', name: '异常' }
        ],
        codehealth: [
          { id: '1', name: '绿码' },
          { id: '2', name: '黄码' },
          { id: '3', name: '红码' },
          { id: '4', name: '灰码' }
        ],
        groupId: '',
        currentPage: 1,
        pageSize: 10,
        totalItems: 0,
        httpCtx: base.httpCtx,
        dataText: '数据加载中...'
      }
    },
    mounted() {
      this.groupId = this.$store.state.groupId
      if ('' == this.groupId) {
        this.$store.commit('setGroupId')
        this.groupId = this.$store.state.groupId
      }
      this
      this.getData()
      // this.getCurArea();
      // this.uploadData.userId = this.$store.state.user.id;
      // this.uploadData.entId = this.entId;
      // this.getOfficeList();
    },
    methods: {
      // 搜索数据
      doFilter() {
        this.getData()
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.currentPage)
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.currentChangePage()
      },
      // 监控当前页码
      currentChangePage(list) {
        this.getData()
      },
      //获取所属区域
      getCurArea() {
        var that = this
        myHttp.getSuperviseById({ id: this.entId }).then(
          function (resp) {
            if (resp.data.code == '200') {
              that.search.areaId = resp.data.data.supervise.areaId
              that.getData()
            }
          },
          function () { }
        )
      },
      // 获取数据
      getData() {
        var that = this
        this.search.pageNum = this.currentPage
        this.search.pageSize = this.pageSize
        this.search.groupId = this.groupId
        this.search.groupType = '1'
        myHttp.getStranger(this.search).then(
          function (resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.stranger.list || []
              for (var i = 0; i < list.length; i++) {
                list[i].index =
                  that.pageSize * (parseInt(that.currentPage) - 1) + (i + 1)
                list[i].photos =
                  list[i].photoFile && list[i].photoFile != ''
                    ? [base.httpCtx + list[i].photoFile]
                    : []
                list[i].photoFile =
                  list[i].photoFile && list[i].photoFile != ''
                    ? base.httpCtx + list[i].photoFile
                    : required('../../../../assets/images/zanwutupian.png')
                // 健康码状态
                if (list[i].healthLevel == '1') {
                  list[i].codeImg = require('../../../../assets/image/anKang-gress.png')
                } else if (list[i].healthLevel == '2') {
                  list[i].codeImg = require('../../../../assets/image/anKang-yellow.png')
                } else if (list[i].healthLevel == '3') {
                  list[i].codeImg = require('../../../../assets/image/anKang-red.png')
                } else if (
                  list[i].healthLevel == '4' ||
                  list[i].healthLevel == '0'
                ) {
                  list[i].codeImg = require('../../../../assets/image/anKang-no.png')
                }

              }
              that.listData = list
              // console.log( that.listData)
              that.totalItems = resp.data.data.stranger.total || 0
              if (that.listData.length == 0) {
                that.dataText = '暂无数据'
              }
            } else {
              that.$message.error(resp.data.msg)
              that.dataText = '暂无数据'
            }
          },
          function () { }
        )
      },
      //导出
      exportOut() {
        var token = this.$store.state.token
        window.open(
          myHttp.exportStranger +
          '?groupId=' +
          this.groupId +
          '&groupType=' +
          this.search.groupType +
          '&time=' +
          this.search.time +
          '&temperatureType=' +
          this.search.temperatureType +
          '&accessToken=' +
          token
        )
      },
      /**
       * 获取项目
       */
      getProject() {
        var that = this
        myHttp
          .getProjectPage({
            pageNum: 1,
            pageSize: 1000
          })
          .then(
            function (resp) {
              if (resp.data.code == '200') {
                var list = resp.data.data.pageInfo.list
                that.projects = list
              } else {
                that.$message.error(resp.data.msg)
              }
            },
            function () { }
          )
      },
      /**
       * 获取省份
       */
      getProvice() {
        var that = this
        myHttp.getProvince().then(
          function (resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.provinceList
              that.provinces = list
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function () { }
        )
      },
      //查看
      handleEdit(index, row) {
        // this.$router.push({name:'reworkHome',params:{id:row.id}})
        this.$router.push('/reworkHome/' + row.projectId)
      },
      //监听区域
      selcetKu(data) { },
      //监听类型
      selcetFlag(data) { }
    }
  }
</script>
<style>
  @import '../../../../assets/css/common.css';
</style>
<style scoped>
  .content>>>.el-card__body {
    padding: 0 !important;
    height: 100% !important;
  }

  .grid-content {
    height: 2.5vh;
    font-size: 1.6vh;
  }

  .aside {
    box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
    border-radius: 10px !important;
    border: 0px !important;
    background-color: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
  }

  .search-section {
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin: 20px 35px 20px 10px;
    height: 40px;
    justify-content: space-between;
  }

  .el-end {
    height: 47px;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    text-align: center;
  }

  .build-table {
    height: calc(100% - 127px);
    width: 98%;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }

  .el-pagination {
    margin: auto;
  }

  .el-table--fit {
    border-bottom: 1px solid #f5f5f5;
  }
</style>